/**
 * Must be imported BEFORE lazysizes (see main.js): lazysizes reads
 * window.lazySizesConfig once at module init.
 *
 * preloadAfterLoad: after window.load, lazysizes quietly loads every remaining
 * .lazyload image on the page during idle time instead of waiting for scroll —
 * so scrolling never hits a blur-up placeholder. Skipped on Save-Data / slow
 * connections.
 *
 * Inside a Chromium prerender (library/speculative-loading.php,
 * library/preload-projects.php) the bulk download is held back until the page
 * is actually shown — otherwise every speculated page would pull all of its
 * images for a visit that may never happen. lazysizes reads preloadAfterLoad
 * live on every check, so flipping it at activation is enough; checkElems()
 * kicks a pass without waiting for a scroll.
 */
import { fastConnection } from './utils'

window.lazySizesConfig = window.lazySizesConfig || {}

if (fastConnection()) {
  if (document.prerendering) {
    document.addEventListener(
      'prerenderingchange',
      () => {
        window.lazySizes.cfg.preloadAfterLoad = true
        window.lazySizes.loader.checkElems()
      },
      { once: true }
    )
  } else {
    window.lazySizesConfig.preloadAfterLoad = true
  }
}
